module.exports = __webpack_public_path__ + "ed8205e4ed0d49cc36662191b78ed9af.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-9.png
// module id = 3233
// module chunks = 0